<template>
  <router-view />
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Work+Sans:wght@100;200;300;400;500;600;700;800;900&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  width: 100%;
  height: 100vh;
  font-family: "Roboto", sans-serif;
  /* overflow: scroll; */
}
html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}
.banner {
  z-index: 100;
}
.container {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
@media (min-width: 576) {
  .container {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
</style>
